// TODO: check if this is still necessary

// We need this class because up-reveal would scroll to the top of the page if the specified selector is not found.
// In our case we want to scroll if the selector exists, otherwise we want the scollposition not to change.
// This is achived by 'up-scroll': true

up.compiler('[scroll-to]', (element) => {

  let selector = element.getAttribute('scroll-to') || '.has-danger'
  let scrollDestinationTag = document.querySelector(selector)

  if (scrollDestinationTag) {
    setTimeout(() => {
      up.reveal(scrollDestinationTag, { behavior: 'smooth', speed: 1.5, padding: '100' })
    }, 0)
  }

})
